var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 430.997,
    height: 178.769,
    viewBox: "0 0 430.997 178.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.042,
    x2: 0.5,
    y2: 0.548,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4aa735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0089ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#037299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#0d3a6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#112459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.064,
    x2: 0.5,
    y2: 0.314,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.062,
    x2: 0.5,
    y2: 0.329,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(-205.821 -208.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M473.765,240.718c-.021-.028.033,0,0,0l-21.313-32.154-2.2,2.724,7.718,16.022,7.357,13.4-31.714-.005-.149.294-5.473,10.8-10.939,20.239h0l-.252.447-4.807,8.836-5.118,10.1h-4.737l-21.858,0-9.9-19.6-4.926-10.8-1.844-3.17-6.15,10.79,6.068,12.52,4.743,9.357,5.452,10.821h11.562l-.022-.042,23.751.005L413.6,301l5.239-10.335L429.6,270.511l.011.507,5.225-9.877,5.118-10.1h.868l27.686.005.014,0-.073-.042a.112.112,0,0,0,.073.042l5.4-10.1Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M535.647,293.482l-29.9,0-28.757-48.149-3.843,7.4,25.955,50.62,36.948.008,12.472-20.328H543.8Z",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M536.593,240.715l-41.026-.008-26.038,50.2h-.975l.037.051-24.052,0-34.051-50.14h0l-.21-.286-36.948-.008-18.675,30.973.014.02-11.639,19.613H313.666l-8.776-20.163,9.988-21.213,31.958-5.32.486-.039,1.819-3.472-.147-.2-40.358-.008-16.15,30.782L307.11,301v0l.21.286h0l19.136,0,22.937.005h0l30.049-49.978,25.361.005,26.7,39.613-.756.016h.768l7.142,10.38.026-.045,37.28.008.105-.208L476,300.99l5.967-11.7.024.032,10.995-20.612h-.027l4.112-8.112,4.607-9.088h1.546l25.68.005,6.174,12.842-26.664,3.037h0l.241,3.205h0l.045,0h.2l32.142.005.017.023,9.032,0,.06-.118Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.781,
    height: 13.945,
    transform: "translate(216.616 339.651)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1.863,
    height: 2.69,
    transform: "translate(216.578 335.783)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M207.012,346.623c0,3.371,2.223,6.973,8.468,6.973h.048v-1.845h-.748c-3.489,0-5.926-2.108-5.926-5.128,0-3.166,3.076-5.127,5.926-5.127h.748v-1.845h-.048C210.495,339.651,207.012,342.518,207.012,346.623Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 1.863,
    height: 2.69,
    transform: "translate(212.049 335.783)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M331.85,350.634h1.842V335.862H331.85ZM317.735,353.6H333.69v-1.844H317.735Zm20.843-17.734V353.6h1.844V335.862Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M270.692,353.207a8.513,8.513,0,0,1-.772-1.3l-.069-.143H219.416v1.845h51.568Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M270.933,344.83l0,0a7.738,7.738,0,0,0-.809,3.481,7.248,7.248,0,0,0,6.816,7.362v-1.835a5.589,5.589,0,0,1,0-11.117V340.9a7.2,7.2,0,0,0-1.594.238A7.38,7.38,0,0,0,270.933,344.83Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M285.1,351.763l-.067.144a8.694,8.694,0,0,1-.769,1.3l-.291.4h24.513v-1.844Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M284.044,351.763c.08-.156.155-.32.226-.489q.039-.094.069-.192l.034-.1c.052-.143.1-.286.149-.438a8.033,8.033,0,0,0,.308-2.229,7.779,7.779,0,0,0-1.06-3.977,7.151,7.151,0,0,0-3.031-2.744,7.79,7.79,0,0,0-2.728-.687v1.832a5.574,5.574,0,0,1,0,11.089v1.831a7.838,7.838,0,0,0,2.929-.773l.061-.028c.038-.02.075-.043.113-.065l.139-.08c.13-.074.262-.148.388-.231l.119-.086c.157-.107.31-.218.459-.337.1-.082.2-.169.325-.29l.062-.057c.04-.035.078-.069.118-.107a6.95,6.95,0,0,0,1.115-1.463l.218-.378Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M281.106,355.054h0Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 1.86,
    height: 2.69,
    transform: "translate(302.076 335.783)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1.842,
    height: 10.983,
    transform: "translate(246.654 339.651)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 1.863,
    height: 2.69,
    transform: "translate(306.604 335.783)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 1.841,
    height: 10.983,
    transform: "translate(306.642 339.651)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 1.861,
    height: 2.689,
    transform: "translate(248.668 355.346)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 1.863,
    height: 2.689,
    transform: "translate(244.138 355.346)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M296.663,346.6a6.524,6.524,0,0,0,1.308,4.035h2.435a5.3,5.3,0,0,1-1.9-4.035c0-3.314,3-5.1,5.828-5.1h1.247v-1.845h-.549C299.869,339.651,296.663,342.314,296.663,346.6Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M313.063,358.039c3.194,0,3.6-2.494,3.6-4.666V339.616h-1.842v13.757c0,1.691-.282,2.816-1.659,2.816a2.136,2.136,0,0,1-.807-.171l-.344-.147-.653,1.721.314.14A3.7,3.7,0,0,0,313.063,358.039Z",
    fill: "#112458"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M632.335,341.614a7.758,7.758,0,0,0-2.729-.687v1.832a5.573,5.573,0,0,1,0,11.089v1.83a7.8,7.8,0,0,0,2.923-.769l.063-.029c.046-.024.09-.05.132-.077l.067-.038c.151-.084.3-.168.447-.263.027-.018.052-.038.117-.086.157-.107.31-.218.459-.338.113-.092.22-.191.367-.327.048-.041.1-.083.138-.126a6.888,6.888,0,0,0,1.115-1.463l.218-.378h-.013c.08-.156.155-.32.226-.49.026-.062.049-.126.07-.191l.033-.1c.055-.144.1-.289.151-.442a8.131,8.131,0,0,0,.306-2.228,7.762,7.762,0,0,0-1.058-3.977A7.176,7.176,0,0,0,632.335,341.614Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M622.53,344.851l0,0a7.719,7.719,0,0,0-.811,3.482,7.247,7.247,0,0,0,6.817,7.361v-1.835a5.589,5.589,0,0,1,0-11.116v-1.827a7.263,7.263,0,0,0-1.594.238A7.365,7.365,0,0,0,622.53,344.851Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M621.517,351.927l-.067-.143-14.125,0v1.848h15.253l-.292-.4A8.736,8.736,0,0,1,621.517,351.927Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M602.654,358.053c3.193,0,3.6-2.493,3.6-4.665V339.631h-1.842v13.757c0,1.691-.283,2.816-1.66,2.816a2.155,2.155,0,0,1-.806-.171l-.344-.147-.654,1.721.314.139A3.682,3.682,0,0,0,602.654,358.053Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M564.832,353.62v-1.845h34.474v1.845Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M560.162,358.053c3.192,0,3.6-2.493,3.6-4.665V339.631h-1.842v13.757c0,1.691-.283,2.816-1.66,2.816a2.155,2.155,0,0,1-.807-.171l-.344-.147-.653,1.721.314.139A3.662,3.662,0,0,0,560.162,358.053Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1.861,
    height: 2.689,
    transform: "translate(561.914 335.792)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M594.384,343.187a3.132,3.132,0,0,1,2.337,1.09,3.968,3.968,0,0,1,.744,2.653v3.754h1.842v-4.055a5.44,5.44,0,0,0-1.186-3.566,4.726,4.726,0,0,0-3.885-1.724l-5.2,0,2.828-5.552h-1.982l-2.94,5.554-.006.012v.015l.8,1.808.013.015Z",
    fill: "#112458"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M445.407,338.213c0-1.558.75-2.327,2.173-2.327h.788v.865h-.654c-.884,0-1.192.4-1.192,1.077h2.462v1.02h-3.577Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 1.844,
    height: 17.734,
    transform: "translate(460.559 335.886)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M411.121,341.606a7.781,7.781,0,0,0-2.728-.688v1.832a5.573,5.573,0,0,1,0,11.089v1.831a7.83,7.83,0,0,0,2.923-.769l.063-.03c.046-.024.09-.05.132-.076l.067-.039c.151-.084.3-.168.446-.263.028-.018.053-.038.118-.086.157-.107.31-.218.459-.337.113-.092.22-.192.366-.327.048-.042.1-.084.139-.127a6.86,6.86,0,0,0,1.114-1.463l.218-.378h-.012c.079-.156.155-.319.226-.489q.037-.095.069-.192l.034-.1c.054-.145.1-.289.151-.442a8.138,8.138,0,0,0,.306-2.229,7.749,7.749,0,0,0-1.059-3.976A7.157,7.157,0,0,0,411.121,341.606Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M401.316,344.842l0,0a7.722,7.722,0,0,0-.811,3.482,7.248,7.248,0,0,0,6.817,7.362v-1.835a5.589,5.589,0,0,1,0-11.116v-1.828a7.214,7.214,0,0,0-1.6.239A7.367,7.367,0,0,0,401.316,344.842Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M400.3,351.919l-.067-.144-34.467,0v1.847h35.594l-.291-.4A8.613,8.613,0,0,1,400.3,351.919Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M414.357,353.62l.291-.4a8.621,8.621,0,0,0,.769-1.3l.068-.144h23.257v1.844Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 1.842,
    height: 19.208,
    transform: "translate(358.916 335.886)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M353.041,355.161a3.682,3.682,0,0,1-1.356-3.231v-7h-1.842v7.251a5.509,5.509,0,0,0,1.913,4.279c1.543,1.177,3.016,1.6,5.631,1.6h3.371V356.2l-4.069,0A6.12,6.12,0,0,1,353.041,355.161Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 1.842,
    height: 14.798,
    transform: "translate(365.77 335.886)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M429.132,345.484a3.857,3.857,0,0,1,1.418-3.075,4.117,4.117,0,0,1,2.727-.849,7.436,7.436,0,0,1,3.484.987l.04.021.791-1.606.019-.039-.039-.02a8.831,8.831,0,0,0-4.45-1.2,5.955,5.955,0,0,0-3.709,1.267,5.777,5.777,0,0,0-2.13,4.6v5.084h1.852v-5.084C429.135,345.544,429.132,345.514,429.132,345.484Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M453.683,352.021a5.537,5.537,0,0,0,1.911-4.291V335.886h-1.842v11.593a3.7,3.7,0,0,1-1.351,3.239,5.946,5.946,0,0,1-3.25,1.027l-.824,0-2.362.008-2.948.016v1.848h5.04A9.192,9.192,0,0,0,453.683,352.021Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 1.84,
    height: 10.975,
    transform: "translate(446.276 339.708)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M542.931,358.053c3.194,0,3.6-2.493,3.6-4.665V339.631h-1.842v13.757c0,1.691-.283,2.816-1.66,2.816a2.159,2.159,0,0,1-.807-.171l-.343-.147-.654,1.721.314.139A3.681,3.681,0,0,0,542.931,358.053Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M505.019,353.653v-1.845H537.23v1.845Zm30.369-2.962V339.709h1.842v10.983Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 1.842,
    height: 14.888,
    transform: "translate(505.019 335.796)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M483.356,353.62V339.675h1.781V353.62Zm-1.136,0c-6.245,0-8.468-3.6-8.468-6.973,0-4.1,3.483-6.97,8.468-6.97h.048v1.845h-.748c-2.849,0-5.926,1.96-5.926,5.125,0,3.02,2.437,5.128,5.926,5.128h.748v1.845Zm1.1-15.123v-2.69h1.863v2.69Zm-4.529,0v-2.69h1.863v2.69Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M488.294,353.62v-1.845h13.249v1.845Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M496.62,341.56a3.132,3.132,0,0,1,2.337,1.09,3.968,3.968,0,0,1,.744,2.653v5.381h1.842V345a5.445,5.445,0,0,0-1.186-3.567,4.728,4.728,0,0,0-3.885-1.723l-4.474,0v1.852Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 1.863,
    height: 2.689,
    transform: "translate(530.838 355.403)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 1.861,
    height: 2.689,
    transform: "translate(535.369 355.403)",
    fill: "#112458"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M217.912,383.423l-.143.2a5.123,5.123,0,0,1-3.877,2.028v1.686a7,7,0,0,0,5.385-2.724l.19-.233Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M213.892,373.151a5.19,5.19,0,0,1,3.877,2.025l.147.2,1.521-.985-.18-.225a6.972,6.972,0,0,0-5.365-2.7Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M212.846,385.607a6.315,6.315,0,0,1,0-12.418v-1.694a7.958,7.958,0,0,0,0,15.807Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M249.145,385.1V371.885h-1.8v10.71Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M238.387,371.885h-2.154L247.116,387.3h2.316Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M236.546,374.141V387.3h1.8V376.685Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 1.78,
    height: 15.412,
    transform: "translate(280.573 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M283.4,373.376h2.881a2.932,2.932,0,1,1,0,5.86H283.4v1.614h3.838a4.364,4.364,0,0,0,3.946-4.543,4.455,4.455,0,0,0-4.792-4.615H283.4Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M288.025,381.9h-2.165l3.449,5.207H291.6Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 3.871,
    height: 1.684,
    transform: "translate(251.772 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.803,
    height: 1.684,
    transform: "translate(259.52 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 1.768,
    height: 15.412,
    transform: "translate(256.689 371.692)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 6.994,
    height: 1.683,
    transform: "translate(269.097 378.367)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 7.149,
    height: 1.684,
    transform: "translate(269.097 385.42)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 1.782,
    height: 15.412,
    transform: "translate(266.305 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 6.994,
    height: 1.683,
    transform: "translate(269.097 378.367)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 6.994,
    height: 1.683,
    transform: "translate(269.097 371.693)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 6.994,
    height: 1.683,
    transform: "translate(225.906 378.367)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 7.149,
    height: 1.684,
    transform: "translate(225.906 385.42)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 1.782,
    height: 15.412,
    transform: "translate(223.115 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 6.994,
    height: 1.683,
    transform: "translate(225.906 378.367)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 6.994,
    height: 1.683,
    transform: "translate(225.906 371.693)",
    fill: "#112458"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M306.712,385.614c-2.99-.312-4.981-2.741-4.981-6.222s1.991-5.911,4.981-6.223V371.5c-4.045.313-6.845,3.482-6.845,7.889s2.8,7.575,6.845,7.889Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M307.758,371.459v1.687c3.133.184,5.236,2.68,5.236,6.246s-2.1,6.061-5.236,6.267v1.666c4.179-.184,7.1-3.436,7.1-7.933S311.937,371.642,307.758,371.459Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 7.126,
    height: 1.684,
    transform: "translate(320.737 371.674)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 1.79,
    height: 15.412,
    transform: "translate(317.901 371.674)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 6.971,
    height: 1.684,
    transform: "translate(320.737 378.348)",
    fill: "#112458"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 1.794,
    height: 15.412,
    transform: "translate(336.132 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M341.147,371.692h-2.174v1.684h2.174a5.585,5.585,0,0,1,5.921,5.877c0,3.746-2.324,6.167-5.921,6.167h-2.174V387.1h2.174c4.656,0,7.785-3.156,7.785-7.851C348.932,374.73,345.8,371.692,341.147,371.692Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 1.794,
    height: 15.412,
    transform: "translate(352.551 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 1.794,
    height: 15.412,
    transform: "translate(375.294 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M365.728,373.126a5.2,5.2,0,0,1,3.934,2.033l.147.2,1.521-.983-.178-.225a6.982,6.982,0,0,0-5.424-2.714Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M364.681,380.585h6.726v-1.623h-6.726Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M369.658,381.632v2.342a5.56,5.56,0,0,1-3.93,1.666v1.685a7.465,7.465,0,0,0,5.614-2.5l.065-.075v-3.115Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M364.681,385.579a6.316,6.316,0,0,1,0-12.4v-1.7a7.957,7.957,0,0,0,0,15.789Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M399.536,372.551,398.555,375l4.7,11.78h2.026Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M399.833,381.036H396.14l-.7,1.75h5.092Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M398.88,371.37h-1.848l-6.158,15.051-.149.361h1.985Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 1.782,
    height: 15.412,
    transform: "translate(384.743 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 3.826,
    height: 1.684,
    transform: "translate(387.572 371.692)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 3.85,
    height: 1.684,
    transform: "translate(379.846 371.692)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 6.184,
    height: 1.684,
    transform: "translate(410.59 385.42)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 1.782,
    height: 15.412,
    transform: "translate(407.784 371.692)",
    fill: "#112458"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 1.78,
    height: 15.412,
    transform: "translate(493.612 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M496.438,373.359h2.882a2.932,2.932,0,1,1,0,5.86h-2.882v1.614h3.838a4.365,4.365,0,0,0,3.947-4.543,4.455,4.455,0,0,0-4.793-4.615h-2.992Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 1.78,
    height: 15.412,
    transform: "translate(626.207 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M629.033,373.359h2.882a2.932,2.932,0,1,1,0,5.86h-2.882v1.614h3.838a4.366,4.366,0,0,0,3.947-4.543,4.455,4.455,0,0,0-4.793-4.615h-2.992Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 1.78,
    height: 15.412,
    transform: "translate(506.682 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M509.508,373.359h2.882a2.932,2.932,0,1,1,0,5.86h-2.882v1.614h3.838a4.366,4.366,0,0,0,3.947-4.543,4.456,4.456,0,0,0-4.793-4.615h-2.992Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M514.133,381.879h-2.165l3.449,5.207h2.291Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M450.494,384.891V371.675h-1.8v10.71Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M439.736,371.675h-2.154l10.883,15.412h2.316Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M437.895,373.931v13.156h1.8V376.475Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M545.744,384.891V371.675h-1.8v10.71Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M534.986,371.675h-2.154l10.883,15.412h2.315Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M533.145,373.931v13.156h1.8V376.475Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 1.78,
    height: 15.412,
    transform: "translate(467.075 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M469.9,373.359h2.882a2.932,2.932,0,1,1,0,5.86H469.9v1.614h3.838a4.366,4.366,0,0,0,3.947-4.543,4.455,4.455,0,0,0-4.793-4.615H469.9Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M474.526,381.879h-2.165l3.449,5.207H478.1Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 1.78,
    height: 15.412,
    transform: "translate(577.914 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M580.74,373.359h2.882a2.932,2.932,0,1,1,0,5.86H580.74v1.614h3.838a4.366,4.366,0,0,0,3.947-4.543,4.455,4.455,0,0,0-4.793-4.615H580.74Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M585.365,381.879H583.2l3.449,5.207h2.291Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 3.871,
    height: 1.684,
    transform: "translate(452.992 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 3.803,
    height: 1.684,
    transform: "translate(460.74 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 1.768,
    height: 15.412,
    transform: "translate(457.91 371.675)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 6.994,
    height: 1.683,
    transform: "translate(483.519 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 7.149,
    height: 1.684,
    transform: "translate(483.519 385.403)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.782,
    height: 15.412,
    transform: "translate(480.727 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 6.994,
    height: 1.683,
    transform: "translate(483.519 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 6.994,
    height: 1.683,
    transform: "translate(483.519 371.675)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 6.994,
    height: 1.683,
    transform: "translate(523.124 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 7.149,
    height: 1.684,
    transform: "translate(523.124 385.403)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 1.782,
    height: 15.412,
    transform: "translate(520.332 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 6.994,
    height: 1.683,
    transform: "translate(523.124 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 6.994,
    height: 1.683,
    transform: "translate(523.124 371.675)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 6.994,
    height: 1.683,
    transform: "translate(552.075 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 7.149,
    height: 1.684,
    transform: "translate(552.075 385.403)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 1.782,
    height: 15.412,
    transform: "translate(549.283 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 6.994,
    height: 1.683,
    transform: "translate(552.075 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 6.994,
    height: 1.683,
    transform: "translate(552.075 371.675)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 6.994,
    height: 1.683,
    transform: "translate(427.835 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 7.149,
    height: 1.684,
    transform: "translate(427.835 385.403)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 1.782,
    height: 15.412,
    transform: "translate(425.043 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 6.994,
    height: 1.683,
    transform: "translate(427.835 378.35)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 6.994,
    height: 1.683,
    transform: "translate(427.835 371.675)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 1.794,
    height: 15.412,
    transform: "translate(620.914 371.675)",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M567.885,385.53c-2.411-.2-3.746-1.756-3.746-4.442v-9.413h-1.817v9.436c0,3.772,2.03,6.018,5.563,6.219Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M572.633,371.675v9.413c0,2.677-1.318,4.234-3.7,4.439v1.8c3.505-.21,5.52-2.452,5.52-6.216v-9.436Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M596.032,379.906v-1.975c-1.653-.482-2.882-1.005-2.882-2.333,0-1.353,1.175-2.333,2.882-2.461v-1.684c-2.814.165-4.766,1.862-4.766,4.211C591.266,378.5,593.758,379.27,596.032,379.906Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M597.078,373.175a4.961,4.961,0,0,1,3.356,1.721l.194.228,1.2-1.332-.153-.175a6.528,6.528,0,0,0-4.6-2.135Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M596.032,385.624a6,6,0,0,1-3.926-2.029l-.2-.228-1.172,1.357.144.171a7.067,7.067,0,0,0,5.152,2.429Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M597.078,378.228v1.979c1.8.54,3.139,1.138,3.139,2.756,0,1.212-.842,2.519-3.139,2.682v1.685c3.669-.2,5-2.41,5-4.456C602.079,379.706,599.349,378.867,597.078,378.228Z",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M614.6,380.033v-1.662h-7.856v-6.7h-1.772v8.358Z",
    fill: "#112458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 1.772,
    height: 6.008,
    transform: "translate(604.973 381.079)",
    fill: "#112458"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 1.782,
    height: 15.412,
    transform: "translate(615.669 371.675)",
    fill: "#112458"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeLogo);
export default __webpack_public_path__ + "static/media/code_logo.2599ec65120ab12022bd28ef901b0cc6.svg";
export { ForwardRef as ReactComponent };